import * as RechartsPrimitive from "recharts"

const ChartArea = RechartsPrimitive.Area

export default ChartArea
